export default __webpack_public_path__ + "static/media/chip_shuffle.2e8eeab5.mp3";